export const SHOPPING_LISTS = 'shopping_lists';
export const MESSAGES = 'messages';
